import { render, staticRenderFns } from "./allFivestar.vue?vue&type=template&id=75cab19c&scoped=true"
import script from "./allFivestar.vue?vue&type=script&lang=js"
export * from "./allFivestar.vue?vue&type=script&lang=js"
import style0 from "./allFivestar.vue?vue&type=style&index=0&id=75cab19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cab19c",
  null
  
)

export default component.exports